<template>
  <div class="li-loading" :class="{ 'li-loading__vertical': vertical }">
    <svg
      v-if="type === 'circular'"
      class="icon_circular"
      :style="{ color, ...iconStyle }"
      viewBox="25 25 50 50"
    >
      <circle cx="50" cy="50" r="20" fill="none" />
    </svg>
    <svg
      v-else-if="type === 'loop'"
      class="icon"
      :style="iconStyle"
      viewBox="0 0 1024 1024"
    >
      <path
        d="M774.50459 210.77c-5.558-3.827-10.73-7.527-15.812-10.695-4.967-3.314-9.808-6.121-14.209-8.785-2.18-1.362-4.373-2.515-6.425-3.673l-5.872-3.281c-0.945-0.551-1.789-0.953-2.625-1.377l-2.425-1.226-4.381-2.233-1.953-1.004-2.219-1.093-3.919-1.924-7.184-3.527c-2.883-1.44-5.995-3.272-8.693-5.22-26.969-19.458-33.058-57.094-13.6-84.063 19.458-26.968 57.095-33.057 84.063-13.599a20840.816 20840.816 0 0 0 10.03 7.236l2.071 1.499 2.62 1.947 5.824 4.351 3.193 2.399c1.091 0.824 2.249 1.676 3.281 2.533l6.735 5.441c2.343 1.915 4.833 3.859 7.308 6.046 4.991 4.313 10.423 8.905 15.952 14.121 5.645 5.071 11.353 10.792 17.394 16.739 5.886 6.125 12.078 12.515 18.185 19.505 12.303 13.875 24.826 29.53 36.839 46.835a494.61 494.61 0 0 1 33.896 56.497 491.342 491.342 0 0 1 27.329 64.159c1.02 2.77 1.888 5.605 2.789 8.428l2.688 8.477c1.691 5.691 3.266 11.429 4.856 17.152l2.136 8.669c0.683 2.896 1.479 5.756 2.051 8.682l1.841 8.729 0.914 4.358 0.785 4.387a479.25 479.25 0 0 1 7.582 69.967c0.302 5.759 0.239 11.514 0.279 17.214l0.017 4.267c0.002 1.42-0.069 2.841-0.101 4.257l-0.25 8.464-0.128 4.204-0.264 4.188-0.53 8.317-0.278 4.451-0.398 3.933-0.793 7.821c-0.14 1.313-0.244 2.561-0.412 3.918l-0.527 4.098-1.056 8.115c-0.185 1.337-0.33 2.695-0.549 4.002-0.216 1.307-0.433 2.61-0.647 3.91l-1.289 7.744c-1.824 10.246-3.91 20.188-6.263 29.766a463.19 463.19 0 0 1-16.343 52.81l-2.255 5.904-1.108 2.899-1.186 2.836-4.611 10.976c-3.247 7.033-6.19 13.723-9.354 19.831-6.048 12.328-12.043 22.661-17.007 31.096-5.121 8.359-9.212 14.84-12.196 19.141l-4.472 6.638 3.293-7.292c2.209-4.713 5.148-11.776 8.748-20.761 3.442-9.059 7.545-20.055 11.346-32.919 2.04-6.376 3.771-13.301 5.726-20.516l2.611-11.204 0.668-2.878 0.583-2.935 1.183-5.957c3.104-16.055 5.567-33.549 6.889-52.052 0.669-9.251 1.027-18.753 1.101-28.437-0.01-2.42-0.021-4.854-0.03-7.3l-0.014-3.67c-0.002-1.227-0.084-2.416-0.121-3.629l-0.284-7.263-0.14-3.644c-0.053-1.229-0.166-2.577-0.246-3.863a14520.752 14520.752 0 0 1-0.798-11.787l-0.018-0.247c-0.013 0.588-0.018 0.028-0.027 0.098l-0.05-0.472-0.101-0.945-0.2-1.891-0.8-7.581a2022.39 2022.39 0 0 1-0.4-3.801l-0.535-3.801-1.069-7.62c-0.188-1.271-0.335-2.545-0.555-3.815l-0.67-3.811c-0.909-5.082-1.708-10.185-2.859-15.253a424.6 424.6 0 0 0-17.057-60.03l-1.316-3.663-1.437-3.623-2.859-7.225c-0.906-2.417-2.029-4.761-3.033-7.135l-3.078-7.082c-2.208-4.653-4.37-9.295-6.624-13.867l-3.508-6.783c-1.167-2.252-2.294-4.513-3.565-6.702a414.254 414.254 0 0 0-31.89-49.502 407.116 407.116 0 0 0-35.476-41.25 406.461 406.461 0 0 0-35.794-32.288c-5.752-4.687-11.515-8.857-16.918-12.861zM0.37459 510.486l0.001-0.005 0.875-7.954 1.051-9.554 0.687-6.125 1.153-8.152c0.828-5.729 1.741-12.089 2.813-18.907l4.259-20.887c0.691-3.726 1.738-7.517 2.729-11.425l3.102-12.024c0.558-2.048 1.019-4.142 1.677-6.221l1.958-6.314 4.07-13.021 1.049-3.333 1.211-3.324c0.814-2.223 1.638-4.467 2.469-6.732 1.673-4.522 3.34-9.131 5.115-13.781l5.938-13.981 3.046-7.123c1.037-2.384 2.247-4.72 3.375-7.102l6.997-14.388c0.569-1.22 1.222-2.408 1.877-3.598l1.958-3.583 3.95-7.211 3.995-7.265c1.354-2.422 2.881-4.773 4.324-7.175l8.875-14.427c12.567-18.998 26.533-37.793 42.018-55.643 15.662-17.71 32.638-34.534 50.581-50.045a527.617 527.617 0 0 1 56.726-41.602c19.622-12.201 39.702-22.647 59.484-31.64l14.925-6.188c2.47-0.995 4.881-2.072 7.356-2.979l7.402-2.651 7.306-2.609 3.615-1.289c1.198-0.434 2.394-0.863 3.618-1.21l14.37-4.353c2.366-0.691 4.68-1.466 7.035-2.069l7.02-1.754 13.669-3.402c4.524-0.941 8.985-1.788 13.341-2.655l6.47-1.271 3.184-0.621 3.186-0.465 12.373-1.797 5.96-0.862c1.957-0.298 3.928-0.403 5.85-0.61l11.239-1.057c3.638-0.329 7.151-0.735 10.598-0.81l19.18-0.823 16.258 0.11 6.935 0.057c2.177 0.091 4.219 0.237 6.115 0.34l9.619 0.566 7.982 0.472-7.959 0.875-9.529 1.05c-1.872 0.215-3.884 0.411-6.023 0.683l-6.797 1.101-15.801 2.578-18.393 3.951c-3.283 0.628-6.614 1.603-10.051 2.514l-10.571 2.838c-1.801 0.509-3.644 0.92-5.469 1.526l-5.542 1.793-11.432 3.697-2.927 0.946-2.914 1.104-5.902 2.242c-3.965 1.517-8.007 3.017-12.084 4.613l-12.243 5.366-6.241 2.733c-2.088 0.929-4.128 2.029-6.212 3.044l-12.59 6.277c-1.068 0.506-2.106 1.094-3.145 1.685l-3.131 1.761-6.302 3.542-6.353 3.568c-2.118 1.209-4.165 2.586-6.263 3.878l-12.601 7.922c-16.565 11.247-32.949 23.681-48.48 37.44a473.639 473.639 0 0 0-43.435 44.87 467.917 467.917 0 0 0-35.892 50.115c-10.476 17.304-19.389 34.971-27.062 52.322-1.761 4.404-3.506 8.772-5.234 13.098-0.843 2.166-1.771 4.273-2.532 6.444l-2.224 6.49-2.201 6.396-1.093 3.162c-0.368 1.047-0.734 2.092-1.019 3.166l-3.633 12.572c-0.578 2.068-1.242 4.086-1.738 6.146l-1.441 6.137-2.829 11.931-2.152 11.645-1.045 5.64-0.514 2.772-0.362 2.779-1.423 10.784-0.697 5.188c-0.245 1.704-0.3 3.423-0.458 5.098l-0.794 9.786c-0.249 3.167-0.584 6.22-0.595 9.223l-0.516 16.686 0.346 13.152 0.109 5.579 0.343 6.014 0.567 9.595 0.472 7.988c0.169 3.219 0.107 6.829-0.256 10.138-3.638 33.056-33.383 56.904-66.438 53.267-33.056-3.637-56.905-33.382-53.268-66.438zM139.16459 762.451l4.868 5.897c1.711 2.052 3.44 4.238 5.4 6.399 3.858 4.365 7.946 9.128 12.608 13.957 4.517 4.944 9.632 9.919 14.922 15.205 5.467 5.131 11.147 10.547 17.374 15.864 12.349 10.726 26.262 21.624 41.613 32.046a434.435 434.435 0 0 0 50.026 29.303 431.157 431.157 0 0 0 56.59 23.39c2.436 0.874 4.935 1.6 7.419 2.361l7.455 2.279c5.006 1.425 10.053 2.742 15.078 4.091 2.536 0.593 5.075 1.187 7.617 1.78 2.545 0.566 5.051 1.25 7.622 1.714l7.663 1.523 3.822 0.763 3.851 0.64a419.278 419.278 0 0 0 61.304 5.938c5.039 0.219 10.081 0.088 15.068 0.072l3.733-0.022c1.238-0.012 2.392-0.1 3.587-0.145l7.067-0.313 3.505-0.146 3.997-0.27 7.961-0.537 1.981-0.133 0.989-0.067 0.494-0.033c-0.221-0.008 0.844-0.005-0.433-0.022l0.226-0.025 3.593-0.396 7.127-0.78a406.59 406.59 0 0 0 53.494-10.013 402.564 402.564 0 0 0 45.809-14.792l5.111-2.022 2.511-0.99 2.451-1.066 9.494-4.124c6.073-2.917 11.861-5.522 17.131-8.352 10.648-5.379 19.552-10.718 26.825-15.11l1.338-0.807a1085.391 1085.391 0 0 1 3.457-2.276l4.116-2.687c0.639-0.414 1.253-0.813 1.843-1.194l2.021-1.354 3.62-2.439 6.637-4.472c2.686-1.782 5.825-3.567 8.857-4.938 30.308-13.689 65.974-0.218 79.662 30.089 13.689 30.308 0.219 65.974-30.089 79.663l-7.293 3.294a9343.8 9343.8 0 0 1-3.979 1.797l-2.369 1.063-2.993 1.302c-2.073 0.896-4.3 1.857-6.676 2.885a8167.08 8167.08 0 0 0-3.672 1.574l-1.918 0.819-1.899 0.745c-10.221 4.014-22.646 8.772-37.189 13.242-7.216 2.375-15.042 4.443-23.216 6.727l-12.687 3.1-3.262 0.787-3.324 0.701-6.75 1.415c-18.195 3.715-38.044 6.719-59.054 8.439a494.284 494.284 0 0 1-65.863 0.997l-8.535-0.519-4.285-0.266-0.268-0.017c-1.44-0.02-0.541-0.02-0.927-0.03l-0.492-0.051-0.986-0.1-1.977-0.201-7.938-0.807-3.991-0.406-4.502-0.554-9.015-1.133c-1.492-0.2-3.034-0.365-4.486-0.598l-4.344-0.709c-5.795-0.965-11.61-1.832-17.399-3.066a485.178 485.178 0 0 1-68.692-18.701l-4.2-1.463-4.157-1.588-8.292-3.176c-2.771-1.016-5.468-2.251-8.194-3.37l-8.134-3.434c-5.351-2.451-10.685-4.869-15.941-7.39l-7.805-3.918c-2.591-1.307-5.188-2.576-7.712-3.991a474.344 474.344 0 0 1-57.071-35.83 467.174 467.174 0 0 1-47.72-40.068 466.596 466.596 0 0 1-37.51-40.586c-5.455-6.542-10.335-13.082-14.998-19.24-4.483-6.313-8.789-12.218-12.512-18-3.868-5.667-7.179-11.177-10.297-16.204-1.589-2.492-2.957-4.989-4.318-7.332-1.349-2.348-2.635-4.586-3.854-6.711-4.686-8.611-8.271-15.384-10.509-20.116l-3.527-7.185 4.682 6.489c2.985 4.266 7.65 10.33 13.635 17.935z"
        :fill="color"
      ></path>
    </svg>
    <span class="text" :style="testStyle" v-if="$slots.default">
      <slot></slot>
    </span>
  </div>
</template>

<script>
import { px2Rem } from "@u/format";
import scss from "@/assets/scss/index.scss";
export default {
  name: "LiLoading",
  props: {
    // loading类型，可选值为 circular | loop
    type: {
      type: String,
      default: "circular"
    },
    // loading颜色
    color: {
      type: String,
      default: scss.color_gray5
    },
    // 图标大小
    size: {
      type: [Number, String],
      default: 60
    },
    // 文字大小
    textSize: {
      type: [Number, String],
      default: 28
    },
    textColor: {
      type: String,
      default: scss.color_gray6
    },
    // 是否垂直排列
    vertical: {
      type: Boolean
    }
  },
  computed: {
    testStyle() {
      return {
        fontSize: px2Rem(this.textSize),
        color: this.textColor
      };
    },
    iconStyle() {
      const width = px2Rem(this.size);
      return {
        width,
        height: width
      };
    }
  }
};
</script>

<style lang="scss">
.li-loading,
.li-loading__vertical {
  display: inline-flex;
  align-items: center;
  .icon,
  .icon_circular {
    width: 30px;
    height: 30px;
    animation: li-rotate 1s linear infinite;
  }

  .icon_circular {
    animation-duration: 2s;
    circle {
      animation: li-circular 1.5s ease-in-out infinite;
      stroke: currentColor;
      stroke-width: 3;
      stroke-linecap: round;
    }
  }

  .text {
    margin-left: 8px;
  }
}

.li-loading__vertical {
  flex-direction: column;
  .text {
    margin: 0;
  }
}

@keyframes li-circular {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120;
  }
}
</style>